import { computed, ref, nextTick, onMounted } from 'vue';
import { useRoute } from 'vue-router';
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, createVNode as _createVNode, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-6ebf22ca"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "table-content"
};
const _hoisted_2 = {
  key: 0,
  class: "handle-content"
};
const _hoisted_3 = {
  key: 1
};
import { copy, OK, reportEvent } from '@/common';
import NewAccountModal from '@/views/payManage/newAccountManage/components/NewAccountModal.vue';
import RecordModal from '@/views/payManage/newAccountManage/components/RecordModal.vue';
import { queryAccountList } from '@/api/payManage/accountManage';
export default /*#__PURE__*/_defineComponent({
  __name: 'NewAccountTableBlock',
  setup(__props, {
    expose
  }) {
    const routeName = computed(() => useRoute().name);
    const columns = [{
      title: '账号简称',
      dataIndex: 'accountName',
      key: 'accountName'
    }, {
      title: '国家',
      dataIndex: 'country',
      key: 'country'
    }, {
      title: '类型',
      dataIndex: 'channelType',
      key: 'channelType'
    }, {
      title: '关联内购产品',
      dataIndex: 'refProductCount',
      key: 'refProductCount'
    }, {
      title: '是否开通订阅',
      dataIndex: 'subscribeEnable',
      key: 'subscribeEnable'
    }, {
      title: '操作内容',
      dataIndex: 'handle',
      key: 'handle',
      align: 'right'
    }];
    const dataSource = ref([]);
    const pageIndex = ref(1);
    const pageSize = ref(20);
    const pageTotal = ref(0);
    const searchObj = ref({});
    const tableRef = ref();
    const detailVisible = ref(false);
    const editItem = ref([]);
    const recordModalRef = ref(); // 详情-变更记录弹窗开关
    const getData = async () => {
      const startTime = new Date().getTime();
      let params = {
        pageNum: pageIndex.value,
        pageSize: pageSize.value
      };
      Object.keys(searchObj.value).forEach(item => {
        if (searchObj.value[item] || searchObj.value[item] === 0) {
          params = {
            ...params,
            [item]: searchObj.value[item]
          };
        }
      });
      try {
        const {
          data: {
            total,
            list
          },
          code
        } = await queryAccountList(params);
        if (code === OK) {
          pageTotal.value = total;
          dataSource.value = list;
          reportEvent({
            eventName: '_search',
            properties: {
              ui_name: '账号管理搜索',
              app_name: '',
              return_duration: (new Date().getTime() - startTime) / 1000,
              query_status: 'succeed'
            }
          });
        } else {
          reportEvent({
            eventName: '_search',
            properties: {
              ui_name: '账号管理搜索',
              app_name: '',
              return_duration: (new Date().getTime() - startTime) / 1000,
              query_status: 'failed'
            }
          });
        }
      } catch (e) {
        reportEvent({
          eventName: '_search',
          properties: {
            ui_name: '账号管理搜索',
            app_name: '',
            return_duration: (new Date().getTime() - startTime) / 1000,
            query_status: 'failed'
          }
        });
      }
    }; // 获取数据
    const searchData = async obj => {
      pageIndex.value = 1;
      searchObj.value = obj;
      await getData();
    };
    const changePage = async (page, pageS) => {
      pageIndex.value = page;
      pageSize.value = pageS;
      await getData();
    };
    const openDetail = async (item, type) => {
      editItem.value = item;
      switch (type) {
        case 'edit':
          detailVisible.value = true;
          break;
        case 'detail':
          nextTick(() => {
            recordModalRef.value.openModal('detail');
          });
          break;
      }
    };
    onMounted(async () => {
      await getData();
    });
    expose({
      searchData
    });
    return (_ctx, _cache) => {
      const _component_a_button = _resolveComponent("a-button");
      const _component_svg_icon = _resolveComponent("svg-icon");
      const _component_a_table = _resolveComponent("a-table");
      const _component_a_pagination = _resolveComponent("a-pagination");
      const _directive_permission = _resolveDirective("permission");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_a_table, {
        bordered: "",
        columns: columns,
        "data-source": dataSource.value,
        "row-key": "id",
        pagination: false,
        ref_key: "tableRef",
        ref: tableRef
      }, {
        bodyCell: _withCtx(({
          column,
          record
        }) => [column.dataIndex === 'handle' ? (_openBlock(), _createElementBlock("div", _hoisted_2, [_withDirectives((_openBlock(), _createBlock(_component_a_button, {
          type: "link",
          onClick: $event => openDetail(record, 'edit')
        }, {
          default: _withCtx(() => [_createTextVNode(" 编辑 ")]),
          _: 2
        }, 1032, ["onClick"])), [[_directive_permission, {
          permissionValue: _unref(routeName),
          btnType: 'update'
        }]]), _createVNode(_component_a_button, {
          type: "link",
          onClick: $event => openDetail(record, 'detail')
        }, {
          default: _withCtx(() => [_createTextVNode("详情")]),
          _: 2
        }, 1032, ["onClick"])])) : _createCommentVNode("", true), column.dataIndex === 'subscribeEnable' ? (_openBlock(), _createElementBlock("div", _hoisted_3, [_createElementVNode("span", null, _toDisplayString(record.subscribeEnable ? '已' : '未') + "开通", 1), record.subscribeEnable ? (_openBlock(), _createBlock(_component_svg_icon, {
          key: 0,
          "icon-class": "copy",
          onClick: $event => _unref(copy)(record.subscribeUrl)
        }, null, 8, ["onClick"])) : _createCommentVNode("", true)])) : _createCommentVNode("", true)]),
        _: 1
      }, 8, ["data-source"]), _createVNode(_component_a_pagination, {
        onChange: changePage,
        current: pageIndex.value,
        "onUpdate:current": _cache[0] || (_cache[0] = $event => pageIndex.value = $event),
        pageSize: pageSize.value,
        "onUpdate:pageSize": _cache[1] || (_cache[1] = $event => pageSize.value = $event),
        total: pageTotal.value,
        "show-size-changer": "",
        "show-total": total => `共 ${total} 条`
      }, null, 8, ["current", "pageSize", "total", "show-total"]), _createVNode(NewAccountModal, {
        "modal-visible": detailVisible.value,
        "onUpdate:modal-visible": _cache[2] || (_cache[2] = $event => detailVisible.value = $event),
        "edit-item": editItem.value,
        "onUpdate:edit-item": _cache[3] || (_cache[3] = $event => editItem.value = $event),
        onRefreshList: getData
      }, null, 8, ["modal-visible", "edit-item"]), _createVNode(RecordModal, {
        ref_key: "recordModalRef",
        ref: recordModalRef,
        currentRow: editItem.value
      }, null, 8, ["currentRow"])]);
    };
  }
});